import { Component, computed, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { EmailItemDto } from '@artemis-software/wr-api';
import { repairTasksVisible } from '@/utils/repair-task-visibility';

@Component({
  standalone: false,
  selector: 'wr-email-type-select',
  templateUrl: './email-type-select.component.html',
  styleUrls: ['./email-type-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmailTypeSelectComponent),
      multi: true,
    },
  ],
})
export class EmailTypeSelectComponent extends AbstractFormControl<EmailItemDto.EmailTypeEnum> {
  readonly EmailType = EmailItemDto.EmailTypeEnum;

  private readonly repairTasksVisible = repairTasksVisible();

  readonly EmailTypes = computed(() => {
    const types = [this.EmailType.Inspection];
    if (this.repairTasksVisible()) {
      types.push(this.EmailType.RepairTask);
    }
    return types;
  });
}
